import { createSelector, createStructuredSelector } from 'reselect';

export const getPrograms = (state) => state.programs;

export const activeProgramsSelector = createSelector(
  getPrograms,
  (programs) => programs.activePrograms
);

export const currentProgramSelector = createSelector(
  getPrograms,
  (programs) => programs.currentProgram
);

export const currentChannelProgramsListSelector = createSelector(
  getPrograms,
  (programs) => programs.currentChannelProgramsList
);

export const currentChannelProgramsMapSelector = createSelector(
  getPrograms,
  (programs) => programs.currentChannelProgramsMap
);

export const isExtendedProgramListSelector = createSelector(
  getPrograms,
  (programs) => programs.isExtendedProgramList
);

export const playingProgramSelector = createSelector(
  getPrograms,
  (programs) => programs.playing
);

export default createStructuredSelector({
  activePrograms: activeProgramsSelector,
  currentProgram: currentProgramSelector,
  playing: playingProgramSelector,
  currentChannelProgramsList: currentChannelProgramsListSelector,
  currentChannelProgramsMap: currentChannelProgramsMapSelector,
  isExtendedProgramList: isExtendedProgramListSelector,
});
